var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wrapper-button", staticStyle: { gap: "8px" } },
    [
      _c(
        "CompassTooltip",
        { attrs: { arrow: false, content: _vm.textTooltipReschedule } },
        [
          _c(
            "ActivitiesRescheduleDatePicker",
            {
              attrs: { value: _vm.activity.date, placement: "bottom-start" },
              on: { "update:value": _vm.onUpdateDueDate }
            },
            [
              _c("CompassIconButton", {
                attrs: {
                  icon: "calendar-reschedule",
                  size: _vm.sizeButton,
                  "data-bot":
                    "activities-listing__action-reschedule-icon-button",
                  disabled: !_vm.canReschedule
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("ActivitiesStatusIconButton", {
        attrs: {
          canUpdate: _vm.activity.acl.can_be_updated,
          isActive: _vm.activity.status.done,
          disabled: !_vm.canUpdateStatusAsDone,
          pending: _vm.activity.status.pending,
          type: _vm.activity.type,
          size: _vm.sizeButton
        },
        on: {
          clicked: function($event) {
            return _vm.$emit("updateStatus")
          }
        }
      }),
      _vm._v(" "),
      _vm.isActivityPage
        ? _c(
            "CompassMenu",
            {
              attrs: {
                customClass: "activity-actions__more-actions-menu",
                placement: "bottom-end"
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "dropdown",
                    fn: function() {
                      return [
                        _c("CompassMenuItem", {
                          attrs: {
                            disabled: !_vm.activity.acl.can_be_updated,
                            label: _vm.$t.__("common.actions.edit"),
                            "data-bot":
                              "activities-listing__action-edit-icon-button",
                            tooltipProps: {
                              disabled: _vm.activity.acl.can_be_updated,
                              arrow: false,
                              content: _vm.$t.__(
                                "common.labels.no_permissions_to_perform_this_action"
                              )
                            }
                          },
                          on: { click: _vm.editActivity }
                        }),
                        _vm._v(" "),
                        _vm.isActivityPage
                          ? _c("CompassMenuItem", {
                              attrs: {
                                disabled: !_vm.activity.acl.can_be_deleted,
                                label: _vm.$t.__("common.actions.delete"),
                                "data-bot":
                                  "activities-listing__action-delete-icon-button",
                                tooltipProps: {
                                  disabled: _vm.activity.acl.can_be_deleted,
                                  arrow: false,
                                  content: _vm.$t.__(
                                    "common.labels.no_permissions_to_perform_this_action"
                                  )
                                }
                              },
                              on: { click: _vm.onDeleteActivity }
                            })
                          : _vm._e()
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                1910955321
              )
            },
            [_c("CompassIconButton", { attrs: { icon: "action" } })],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }